// src/components/navbar/ui/NavbarCta.jsx

import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { cn } from "../utils/navbarUtils";

export default function NavbarCta({
  onClick,
  transparent = false,
  children = "Parler de mon projet",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "group inline-flex h-11 items-center justify-center gap-3 rounded-full",
        "px-5 text-sm font-semibold transition-all duration-300",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ff7900]",
        transparent
          ? [
              "border border-white/25 bg-white text-[#0868f2]",
              "shadow-[0_12px_30px_-18px_rgba(0,0,0,0.55)]",
              "hover:-translate-y-0.5 hover:bg-white/90",
            ]
          : [
              "border border-[#0868f2] bg-[#0868f2] text-white",
              "shadow-[0_12px_28px_-16px_rgba(8,104,242,0.75)]",
              "hover:-translate-y-0.5 hover:border-[#0648b8] hover:bg-[#0648b8]",
            ],
      )}
    >
      <span>{children}</span>

      <span
        className={cn(
          "grid h-6 w-6 place-items-center rounded-full transition-transform",
          "bg-[#ff7900] text-white group-hover:translate-x-0.5",
        )}
      >
        <FaArrowRight className="text-[9px]" />
      </span>
    </button>
  );
}